import React from "react";
import "./Main.css";


export default function Main() {
  return (
    <>
      <span className="first-Title">
        <h1>Seasons Finest</h1>
      </span>
      <span className="pra">
        <p>Flowers</p>
        <p>Plants</p>
      </span>
      <div className="Carousel">
      

      </div>
    </>
  );
}
